import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { Toaster } from "sonner";

import { RouteError } from "@/features/shell/RouteError";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => (
    <>
      <Outlet />
      {/* Above the registration page's action bar, so a message never covers Save. */}
      <Toaster position="bottom-center" offset={{ bottom: 88 }} mobileOffset={{ bottom: 84 }} toastOptions={{ className: "font-sans" }} />
    </>
  ),
  errorComponent: RouteError,
});
